module.exports = __webpack_public_path__ + "12a5741eb717991210fcf2a74becbd66.svg";